import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

/**
 * Impressions Composable
 * Bietet Zugriff auf General Images (Impressionen) aus der API
 */
export function useImpressions() {
  const apiStore = useApiStore()

  return {
    // Data
    impressions: computed(() => apiStore.impressions),
    loading: computed(() => apiStore.impressionsLoading),
    error: computed(() => apiStore.impressionsError),
    hasImpressions: computed(() => apiStore.hasImpressions),

    // Methods
    load: () => apiStore.loadImpressions()
  }
}